import { g as s } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as n, normalizeClass as r, createElementVNode as e } from "vue";
import { _ as d } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconTelegram",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(i).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = s();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], _ = ["fill"], f = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.527 11.895a496.375 496.375 0 0 1 5.831-2.513c2.777-1.155 3.354-1.355 3.73-1.362.083-.001.268.02.388.116a.421.421 0 0 1 .143.271c.013.078.03.255.016.394-.15 1.581-.802 5.418-1.133 7.19-.14.749-.416 1-.683 1.025-.58.053-1.022-.384-1.584-.753-.88-.577-1.378-.936-2.232-1.499-.987-.65-.347-1.008.215-1.593.148-.153 2.706-2.48 2.756-2.691.006-.026.012-.125-.047-.177-.058-.052-.144-.034-.207-.02-.088.02-1.494.95-4.218 2.788-.399.274-.76.408-1.084.4-.357-.007-1.044-.201-1.555-.367-.626-.204-1.124-.311-1.08-.657.022-.18.27-.364.744-.552Z",
  fill: "#fff"
}, null, -1), m = ["id"], p = /* @__PURE__ */ e("stop", { "stop-color": "#2AABEE" }, null, -1), h = /* @__PURE__ */ e("stop", {
  offset: "0",
  "stop-color": "#2AABEE"
}, null, -1), g = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#229ED9"
}, null, -1), E = [
  p,
  h,
  g
];
function I(t, S, o, b, q, a) {
  return n(), l("svg", {
    "aria-label": o.ariaLabel,
    class: r([a.iconSizeClass, "d-icon d-icon--telegram"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Telegram",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("path", {
      d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
      fill: `url(#${t.uniqueID}a)`
    }, null, 8, _),
    f,
    e("defs", null, [
      e("linearGradient", {
        id: `${t.uniqueID}a`,
        x1: "12",
        y1: "2",
        x2: "12",
        y2: "21.852",
        gradientUnits: "userSpaceOnUse"
      }, E, 8, m)
    ])
  ], 10, u);
}
const x = /* @__PURE__ */ d(c, [["render", I]]);
export {
  x as default
};
//# sourceMappingURL=telegram.js.map
